<template>
  <div
    id="main1"
    ref="main1"
  ></div>
</template>
<script>
import { initResizeListener } from '@/utils/utils';

export default {
  data() {
    return {
      myChart1: null,
    };
  },
  props: {
    data: Array,
  },
  watch: {
    data(newVal) {
      this.setChartOption(newVal);
    },
    skinType() {
      this.setChartOption(this.data);
    },
  },
  mounted() {
    this.setChartOption(this.data);
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    setChartOption(chartData) {
      if (this.myChart1 === null) {
        this.myChart1 = this.$echarts.init(this.$refs.main1);
        initResizeListener(this.myChart1, this.$refs.main1);
      }
      if (chartData.length === 0) {
        this.myChart1.clear();
      } else {
        const option11 = {
          title: {
            text: '各台变压器用电量',
            top: 0,
            left: 10,
            textStyle: {
              fontWeight: 'bold',
              fontSize: '14',
              color: 'auto',
            },
          },
          grid: {
            containLabel: true,
          },
          label: {
            formatter: '{b|{b}:}{c|{c}} \n {per|{d}%\n}  ',
            rich: {
              a: {
                color: '#6E7079',
                lineHeight: 22,
                align: 'center',
              },
              b: {
                color: this.skinType ? '#fff' : '#4C5058',
                fontSize: '12',
              },
              c: {
                color: 'auto',
                fontSize: '12',
              },
              per: {
                color: 'auto',
                padding: [3, 4],
                borderRadius: 4,
                align: 'center',
              },
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: ' {b}：{c} ',
          },
          legend: {
            orient: 'vertical',
            left: '5%',
            top: '20%',
            itemGap: 5,
            itemWidth: 20,
            itemHeight: 10,
            textStyle: {
              fontSize: '14',
              color: 'auto',
            },
          },
          series: [
            {
              type: 'pie',
              radius: ['30%', '50%'],
              center: ['65%', '50%'],
              data: chartData,
              itemStyle: {
                normal: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                  },
                },
              },
            },
          ],
          color: [
            '#FFAF8E',
            '#667EEB',
            '#75B2FB',
            '#08BED3',
            '#F67CA3',
            '#7FC4C2',
            '#7a81b5'],
        };
        this.$nextTick(() => {
          this.myChart1.setOption(option11, true);
        });
      }
    },
  },
};
</script>
